import { componentStyles } from "./Automations.scss";

const automations = [
    {
        src: "https://dapulse-res.cloudinary.com/image/upload/template_center/automations/automation1.png",
        description: "When due date arrives, notify item subscribers"
    },
    {
        src: "https://dapulse-res.cloudinary.com/image/upload/template_center/automations/automation2.png",
        description: "When priority changes to high, move item to group high priority"
    },
    {
        src: "https://dapulse-res.cloudinary.com/image/upload/template_center/automations/automation3.png",
        description: "When status changes to done, create an update"
    }
];

const AutomationsComponent = () =>
<div className="automations-wrapper">
    {automations.map(a => <img className="automation-image" src={a.src} alt={a.description}></img>)}
    <style jsx>{componentStyles}</style>
</div>

export default AutomationsComponent;